import React from 'react';
import ReactDOM from 'react-dom';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';

export const OrbitComponentsRenderedInsideSdkContainer = observer(class OrbitComponentsRenderedInsideSdkContainer extends OrbitComponent {
    render() {
        const componentsPortals = this.services.orbitComponentInsideSdkProvider.currentRenderedComponents.map(item => ReactDOM.createPortal(item.component, item.element))
        if(componentsPortals.length === 0) {
            return null;
        }

        return (<>
            {componentsPortals}
        </>);
    }
});